import { Injectable } from '@angular/core';
import { Cliente } from '../models/cliente';
import { Observable } from 'rxjs/Rx';
import { Filtro } from '../models/filtro';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { AtualizaDA } from '../models/atualizaDA';
import { ConsultaListaTokenVM } from '../models/consulta-lista-token-vm';

@Injectable({
  providedIn: "root",
})
export class ClienteService {
  constructor(private globalService: GlobalService, private http: HttpClient) { }

  consultarPorIdCliente(idCliente, gi) {
    let params = new HttpParams()
      .set("id", idCliente);

    if (gi) {
      params = params.set("gi", gi);
    }

    return this.http.get<any>(globals.apiUrl + "/api/Cliente/Buscar", {
      params,
    });
  }

  consultarPorIdClienteSimples(idCliente) {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/BuscarSimples", {
      params: new HttpParams().set("id", idCliente),
    });
  }

  consultarPorDoc(doc, tipo) {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/BuscarPorDoc", {
      params: new HttpParams().set("doc", doc).set("tipo", tipo),
    });
  }

  consultarPorIdClienteFaturamento(idCliente) {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/BuscarClienteFaturamento", {
      params: new HttpParams().set("id", idCliente),
    });
  }

  consultarAtualizadoReceita(idCliente: number, gi: boolean, ignoraErros: boolean = false) {
    return this.http.get<Cliente>(globals.apiUrl + "/api/Cliente/BuscarAtualizadoReceita", {
      params: new HttpParams().set("id", idCliente.toString()).set("gi", gi.toString()).set("ignoraErros", ignoraErros.toString()),
    });
  }

  inserir(cliente: Cliente, idContato, url) {
    return this.http.post(globals.apiUrl + "/api/Cliente/Inserir", { cliente, idContato, url });
  }

  atualizar(cliente: Cliente) {
    return this.http.post(globals.apiUrl + "/api/Cliente/Atualizar", cliente);
  }

  atualizarDA(dados: AtualizaDA) {
    return this.http.post(globals.apiUrl + "/api/Cliente/AtualizarDA", dados);
  }

  consultarEnderecoDeEntrega(idCliente) {
    return this.http.get(globals.apiUrl + "/api/Cliente/EndeEntrega", {
      params: new HttpParams().set("id", idCliente),
      responseType: "text",
    });
  }

  salvarClienteVendaDireta(cliente: Cliente) {
    return this.http.post(globals.apiUrl + "/api/Cliente/SalvarClienteVendaDireta", cliente);
  }

  consultaListaAvancada(
    descricao: string,
    ativo,
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    gi,
    tipoPesquisa,
    pesquisa: string,
    pesquisarPorVendedor,
    idVendedor,
    pesquisaGeral,
    uf,
    cidade,
    tags
  ) {
    let parametros = new HttpParams()
      .set("pag", paginaAtual)
      .set("qt", qtdRegistros)
      .set("ordem", campoOrdenacao)
      .set("asc_desc", orientacaoOrdenacao)
      .set("ativo", ativo !== undefined && ativo !== null ? ativo : "")
      .set("gi", gi)
      .set("tipoPesquisa", tipoPesquisa !== undefined && tipoPesquisa !== null ? tipoPesquisa : "")
      .set("pesquisa", pesquisa ? encodeURIComponent(pesquisa) : "")
      .set(
        "pesquisarPorVendedor",
        pesquisarPorVendedor !== undefined && pesquisarPorVendedor !== null ? pesquisarPorVendedor : "false"
      )
      .set("idVendedor", idVendedor !== undefined && idVendedor !== null ? idVendedor : "")
      .set("pesquisaGeral", pesquisaGeral !== undefined && pesquisaGeral !== null ? pesquisaGeral : "false")
      .set("uf", uf !== undefined && uf !== null ? uf : "")
      .set("cidade", cidade !== undefined && cidade !== null ? cidade : "")
      .set("tags", tags !== undefined && tags !== null ? tags : "");

    if (descricao.trim() !== "") {
      parametros = parametros.set("descri", descricao);
    }

    return this.http.get<any>(globals.apiUrl + "/api/Cliente/ListaAvancada", {
      params: parametros,
    });
  }

  consultarClientesComPaginacao(
    descricao: string,
    ativo,
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    gi,
    tipoPesquisa,
    pesquisa: string,
    pesquisarPorVendedor,
    idVendedor,
    pesquisaGeral,
    aptoBancoFinanciamento
  ) {
    let parametros = new HttpParams()
      .set("pag", paginaAtual)
      .set("qt", qtdRegistros)
      .set("ordem", campoOrdenacao)
      .set("asc_desc", orientacaoOrdenacao)
      .set("ativo", ativo !== undefined && ativo !== null ? ativo : "")
      .set("gi", gi)
      .set("tipoPesquisa", tipoPesquisa !== undefined && tipoPesquisa !== null ? tipoPesquisa : "")
      .set("pesquisa", pesquisa ? encodeURIComponent(pesquisa) : "")
      .set(
        "pesquisarPorVendedor",
        pesquisarPorVendedor !== undefined && pesquisarPorVendedor !== null ? pesquisarPorVendedor : "false"
      )
      .set("idVendedor", idVendedor !== undefined && idVendedor !== null ? idVendedor : "")
      .set("pesquisaGeral", pesquisaGeral !== undefined && pesquisaGeral !== null ? pesquisaGeral : "false")
      .set(
        "aptoBancoFinanciamento",
        aptoBancoFinanciamento !== undefined && aptoBancoFinanciamento !== null ? aptoBancoFinanciamento : ""
      );

    if (descricao.trim() !== "") {
      parametros = parametros.set("descri", descricao);
    }

    return this.http.get<any>(globals.apiUrl + "/api/Cliente/ListaPag", {
      params: parametros,
    });
  }

  consultarTransportadoras() {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/Transportadoras");
  }

  consultarCidadesDosClientes() {
    return this.http.get<string[]>(globals.apiUrl + "/api/Cliente/ListaCidade");
  }

  gerarTokenIntegracao() {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/GerarTokenIntegracao");
  }

  consultarClientesDoVendedor(idVendedor, pegarHierarquia = null) {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/BuscarClientesDoVendedor", {
      params: new HttpParams()
        .set("idVendedor", idVendedor ? idVendedor : "")
        .set("pegarHierarquia", pegarHierarquia ? pegarHierarquia : ""),
    });
  }

  buscarDescontoMaximo(idCliente) {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/BuscarDescontoMaximo", {
      params: new HttpParams().set("id", idCliente),
    });
  }

  salvarTags(idIntegrador, tags) {
    return this.http.post<any>(globals.apiUrl + "/api/Cliente/SalvarTags", { idIntegrador, tags });
  }

  bloquear(idCliente) {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/Bloquear", {
      params: new HttpParams().set("idCliente", idCliente),
    });
  }

  ativar(idCliente) {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/Ativar", {
      params: new HttpParams().set("idCliente", idCliente),
    });
  }

  enviarDadosSub(idIntegrador) {
    return this.http.post<any>(
      globals.apiUrl + "/api/Cliente/EnviarDadosSub",
      {},
      { params: new HttpParams().set("idIntegrador", idIntegrador) }
    );
  }

  solicitarCriacaoDeToken(idCliente?) {
    let params = new HttpParams();

    if (idCliente) {
      params = params.set("idCliente", idCliente);
    }

    return this.http.get<any>(globals.apiUrl + "/api/Cliente/SolicitarCriacaoDeToken", { params });
  }

  consultarTokenSolicitado() {
    return this.http.get<string>(globals.apiUrl + "/api/Cliente/BuscarTokenSolicitado");
  }

  salvarToken(token) {
    return this.http.post<any>(
      globals.apiUrl + "/api/Cliente/SalvarToken",
      {},
      { params: new HttpParams().set("token", token) }
    );
  }

  consultarTokenPorIdCliente(idCliente, gi) {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/BuscarTokenCliente", {
      params: new HttpParams().set("id", idCliente).set("gi", gi),
    });
  }

  consultarListaTokensSolicitados(vm: ConsultaListaTokenVM) {
    return this.http.post<any>(globals.apiUrl + "/api/Cliente/BuscarListaTokensSolicitados", vm);
  }

  aprovarSolicitacao(idToken) {
    return this.http.post<any>(
      globals.apiUrl + "/api/Cliente/AprovarSolicitacaoToken",
      {},
      { params: new HttpParams().set("idToken", idToken) }
    );
  }

  liberarSolicitacao(idToken) {
    return this.http.post<any>(
      globals.apiUrl + "/api/Cliente/LiberarSolicitacaoToken",
      {},
      { params: new HttpParams().set("idToken", idToken) }
    );
  }

  reprovarSolicitacao(idToken) {
    return this.http.post<any>(
      globals.apiUrl + "/api/Cliente/ReprovarSolicitacaoToken",
      {},
      { params: new HttpParams().set("idToken", idToken) }
    );
  }

  bloquearSolicitacao(idToken) {
    return this.http.post<any>(
      globals.apiUrl + "/api/Cliente/BloquearSolicitacaoToken",
      {},
      { params: new HttpParams().set("idToken", idToken) }
    );
  }

  importarTokensExistentesComoSolicitacao() {
    return this.http.get<any>(globals.apiUrl + "/api/Cliente/ImportarTokensExistentesComoSolicitacao");
  }

  exportarSolicitacoesToken(vm: ConsultaListaTokenVM) {
    return this.http.post<any>(globals.apiUrl + "/api/Cliente/ExportarSolicitacoesToken", vm, {
      responseType: "blob",
    } as any);
  }

  exportarContatos(ids, titulo) {
    let parametros = new HttpParams().set("ids", ids.toString()).set("titulo", titulo);

    return this.http.get(globals.apiUrl + "/api/Contato/ExportarContato", { responseType: "blob", params: parametros });
  }

  forcaAtualizacaoReceita(idIntegrador) {
    return this.http.get<any>(`${globals.apiUrl}/api/Cliente/ForcaAtualizacaoReceita`, {
      params: new HttpParams().set("id", idIntegrador),
    });
  }

  consultarClassificacaoIntegrador(idIntegrador) {
    return this.http.get<any>(`${globals.apiUrl}/api/Cliente/ConsultarClassificacaoIntegrador`, {
      params: new HttpParams().set("id", idIntegrador),
    });
  }

  consultarImagemPorId(idClassificacao) {
    return this.http.get(`${globals.apiUrl}/api/Cliente/BuscarImagemClassificacao`, {
      params: new HttpParams().set("id", idClassificacao).set("thumb", "false"),
      responseType: "blob",
    });
  }

  geraTextoSimplesNacional(cliente: Cliente) {
    let optante = "Sem informações";

    if (cliente.optanteSimples != null) {
      optante = cliente.optanteSimples ? "Optante" : "Não Optante";
    }

    if (cliente.optanteSimples === true && cliente.dataSituacaoSimples) {
      const data = new Date(cliente.dataSituacaoSimples);
      return `${optante} (desde ${data.toLocaleDateString()})`;
    } else {
      return `${optante}`;
    }
  }

  geraTextoSimei(cliente: Cliente) {
    let optante = "Sem informações";

    if (cliente.optanteSimei != null) {
      optante = cliente.optanteSimei ? "Optante" : "Não Optante";
    }

    if (cliente.optanteSimei === true && cliente.dataSituacaoSimei) {
      const data = new Date(cliente.dataSituacaoSimei);
      return `${optante} (desde ${data.toLocaleDateString()})`;
    } else {
      return `${optante}`;
    }
  }

  geraTextoAtualizacaoReceita(cliente: Cliente) {
    const fonte = cliente.fonteAtualizacaoReceita != null ? cliente.fonteAtualizacaoReceita : "Sem informações";

    if (cliente.dataAtualizacaoReceita) {
      const data = new Date(cliente.dataAtualizacaoReceita);
      return `${fonte} (em ${data.toLocaleDateString()})`;
    } else {
      return `${fonte}`;
    }
  }

  exportarPlanilhaTransVendedores() {
    return this.http.get(globals.apiUrl + '/api/Cliente/ExportarPlanilhaTransVendedores',
      { responseType: 'blob' }
    );
  }

  importarPlanilhaTransVendedores(dados) {
    return this.http.post(globals.apiUrl + '/api/Cliente/ImportarPlanilhaTransVendedores',
      dados,
      {
        responseType: 'blob'
      });
  }
}
